<template>
  <div>
    <!-- 申请充值模态框 -->
    <el-dialog
      title="支付宝授权"
      :visible.sync="isVisible"
      width="40%"
      :before-close="openAuthClose"
    >
        <div v-if="applicationProcess == 1">
            <el-form
              :model="AuthFormData"
              :rules="AuthDialogRules"
              ref="AuthForm"
              label-position="right"
              label-width="96px"
            >
              <el-form-item label="金额" prop="money">
                <el-input v-model="AuthFormData.money" placeholder="请输入金额"></el-input>
              </el-form-item>
              <el-form-item label="备注" prop="remark">
                <el-input type="textarea" v-model="AuthFormData.remark" placeholder="请输入备注"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button size="medium" @click="AuthDialogClose">取 消</el-button>
              <el-button size="medium" type="primary" :disabled="loading" @click="checkAuth" >提交</el-button>
            </div>
        </div>
        
        <div class="qr-code-wrapper" v-if="applicationProcess == 2">
          <div class="content">
              <div class="url">
                链接地址： <span>
                    <a target="_blank" :href="showCoentent.url||'#'">点击此处</a>跳转至授权链接
                </span>
                
                <div ref="copyText" class="copyMsg">{{showCoentent.url}}
                </div>
                
                <el-button size="small" class="btn copyBtn" @click="copyText()" type="primary">复制链接</el-button>
              </div>
              <div>
                订单号： <span>
                    {{showCoentent.outer_trade_no}}
                </span>
              </div>
          </div>
          
          <div class="qr-code-tips">*复制链接到网页打开进行授权入金</div>
          
          <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="AuthDialogClose">关闭</el-button>
          </div>
        </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    data:{
        type: Object,
        default:()=>{
            return {}
        }
    }
  },
  components: {
  },
  data() {
    return {
      showCoentent:{},
      loading:false,
      applicationProcess: 1,
      AuthFormData: {
        remark: '',
        money: ''
      },
      AuthDialogRules: {
        abstract: [{
          required: true, message: '请输入备注', trigger: 'blur'
        }],
        money: [{
          required: true, message: '请输入金额', trigger: 'blur'
        }]
      },
    };
  },
  watch: {
  },
  methods: {
      //一键复制
      copyText() {
        var that = this;
        if (!that.isCopy) {
          var clipboard = new this.clipboard(".copyBtn", {
            target: function () {
              return that.$refs.copyText;
            },
          });
        }
        clipboard.on("success", function () {
          that.$message.success("复制成功");
        });
        clipboard.on("error", function () {
          that.$message.success("复制失败");
        });
        that.isCopy = true;
      },
    openAuthClose(done){
        done()
        this.AuthDialogClose()
    },
    //确定完成充值事件
    async checkAuth() {
        this.$refs["AuthForm"].validate(async (valid) => {
          if (valid) {
            let obj = {
                  ...this.data,
                  ...this.AuthFormData
              }
              console.log(obj)
              let res = await this.$api.postAlipayRecharge(this.data.company_id, obj);
              let {
                  url,outer_trade_no
              } = res;
              if(!url){
                  this.AuthDialogClose()
              }
              this.$nextTick(() => {
                if (res) {
                    this.showCoentent = {
                        url,
                        outer_trade_no
                    }
                  this.applicationProcess = 2;
                }
              });
            // this.$emit('emitCheckAuth', this.AuthDialogData.visible)
            this.AuthFormData = {}
            this.AuthDialogRules = {}
          }
        });
    },
    //申请充值关闭事件
    AuthDialogClose() {
      this.applicationProcess = 1
      this.AuthFormData={}
      this.$emit('emitAuthDialogClose')
    },
  }
};
</script>
<style lang="stylus" scoped>
.copyMsg{
    opacity 0
    position absolute
    z-index -1
    width 10px
    height 10px
    overflow hidden
}
.content
  div
    margin 20px
    font-size 18px
.qr-code-wrapper
  .content
    margin-bottom 30px
  .url
    display flex
    align-items center
    .btn
      margin-left 20px
.qr-code-tips
  text-align: center
  margin-bottom: 40px
  color: #EE0A0A
.Auth-success
  display: flex;
  justify-content: center;
.Auth-success-tips
  font-size: 20px
  margin-top:10px
  padding: 0 10px
.dialog-footer
  display flex
  justify-content center
  align-items center
  /deep/.el-button
    min-width 100px
    margin-right 10px
</style>
